export default __webpack_public_path__ + "static/img/about-texture.105b082.jpg";